import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "video",
  class: "absolute inset-0 rounded-md h-60 m-0 max-w-fit pointer-events-none",
  loop: "",
  autoplay: "",
  muted: ""
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "truncate text-xs max-w-60 w-60 block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode("\n\t\twe use target=\"_blank\" to open the example in the new tab,\n\t\tas I can only occasionally save an example scene in prod,\n\t\tand that seems to be due to CSRF token not recognized.\n\t\tA new tab may fix this.\n\t"),
    _createVNode(_component_router_link, {
      to: _ctx.exampleData.href,
      class: "group relative block hover:opacity-90 mx-auto lg:mx-0",
      onMouseenter: _ctx.onMouseenter,
      onMouseleave: _ctx.onMouseleave,
      title: _ctx.exampleData.name,
      target: "_blank"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "relative rounded-md overflow-hidden bg-gray-200 h-60 w-60 min-w-60 bg-cover bg-center",
          style: _normalizeStyle(_ctx.thumbnailStyleObject)
        }, [
          (_ctx.videoDisplayed)
            ? (_openBlock(), _createElementBlock("video", _hoisted_1, [
                _createElementVNode("source", {
                  src: _ctx.exampleData.videoUrl,
                  type: "video/mp4"
                }, null, 8 /* PROPS */, _hoisted_2)
              ], 512 /* NEED_PATCH */))
            : _createCommentVNode("v-if", true)
        ], 4 /* STYLE */),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.exampleData.label), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["to", "onMouseenter", "onMouseleave", "title"])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}